import { render, staticRenderFns } from "./editSucai.vue?vue&type=template&id=2cc7ca1c&scoped=true&"
import script from "./editSucai.vue?vue&type=script&lang=js&"
export * from "./editSucai.vue?vue&type=script&lang=js&"
import style0 from "./editSucai.vue?vue&type=style&index=0&id=2cc7ca1c&lang=scss&scoped=true&"
import style1 from "./editSucai.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7ca1c",
  null
  
)

export default component.exports